export class WasmCodeNotFoundException extends Error {}
